module.exports = __webpack_public_path__ + "img/ic_qrcode.07255158.png";